import React from 'react';
import TextInput from '@adsk/alloy-react-text-input';
import { CustomAttribute } from '../../sdk/types/common/customAttribute';

export type TextAttributeInputProps = {
  attribute: CustomAttribute;
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  ['data-testid']?: string;
};

/**
 * Layer A primitive: renders only the text input for a custom attribute. No
 * `CommonFormField` wrapper, no label, no error message — consumers wrap this
 * in whatever field chrome their screen needs.
 *
 * Pattern mirrors `PureEnumMultiDropdown` (raw) vs `PureEnumMultiDropdownField`
 * (with `CommonFormField`).
 */
export const TextAttributeInput = ({
  attribute,
  value,
  onChange,
  disabled,
  placeholder,
  error,
  'data-testid': dataTestId,
}: TextAttributeInputProps) => (
  <TextInput
    name={`custom-attr-${attribute.id}`}
    value={value}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    disabled={disabled}
    placeholder={placeholder}
    data-testid={dataTestId ?? `custom-attr-${attribute.id}`}
    error={!!error}
  />
);
